<template>
  <v-flex class="applyNow-container pa-4" data-qa="applynow-flex-xguy3">
    <v-flex class="px-1" v-if="noOffersAvailable" data-qa="applynow-flex-qs4p9">
      <p class="pt-5 headline text-center" data-qa="applynow-p-05f6cw">
        <font :color="primaryColor">{{ $t("common.offersNotFound") }}</font>
      </p>
      <p class="pt-5 text--subtitle-2 text-center" data-qa="applynow-p-9u1iug">
        {{ $t("common.noOffersAvailable") }}
      </p>
    </v-flex>
    <Loader v-show="loaderEnabled"/>
    <v-card v-if="!noOffersAvailable && offerList" data-qa="applynow-card-n2yrpl">
      <v-card-title data-qa="applynow-card-title-xc5rn">
        <v-spacer data-qa="applynow-spacer-42w0t8"></v-spacer>
        <v-text-field
          v-model="searchOffer"
          @input="filterOfferList"
          data-qa="searchOffer"
          :color="primaryColor"
          append-icon="mdi-magnify"
          label="Search Offers"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-tabs
        v-model="currentTab"
        grow
        background-color="#EEEEEE"
        color="deep-purple accent-4"
        class="applyNow-container__tabPadding"
       data-qa="applynow-tabs-wk5b5">
        <v-tab
          v-for="(offers, i) in offerList"
          :key="offers.type"
          @click="resetOfferData()"
          class="text-subtitle-1"
          style="text-transform: none !important"
          :data-qa="`applynow-tab-2j0v8-${i}`"
          >{{ offers.label }}</v-tab
        >
      </v-tabs>
      <v-tabs-items v-model="currentTab" data-qa="applynow-tabs-items-6io6ri">
        <v-tab-item v-for="(offerItem, i) in offerList" :key="offerItem.type" :data-qa="`applynow-tab-item-2j0v8-${i}`">
          <v-container fluid :data-qa="`applynow-container-a10k6v-${i}`">
            <v-expansion-panels
              v-model="offerItem.expansionGroup"
              :readonly="
                offerItem.type === 'SVGS' || offerItem.type === 'CACC'
                  ? true
                  : false
              "
              :data-qa="`applynow-expansion-panels-u24m9-${i}`">
              <v-expansion-panel
                v-for="(group, idx) in offerItem.groups"
                :key="group.label"
                class="elevation-2"
                :data-qa="`applynow-expansion-panel-2j0v8-${i}-${idx}`"
              >
                <v-expansion-panel-header v-if="offerItem.showGroups" :data-qa="`applynow-expansion-panel-header-4xjoob-${i}-${idx}`">
                  <font class="body-1 font-weight-medium" :color="primaryColor">
                    <span :data-qa="`applynow-span-f9f1pn-${i}-${idx}`">{{ group.label }}</span>
                  </font>
                </v-expansion-panel-header>
                <v-expansion-panel-content :data-qa="`applynow-expansion-panel-content-7ju6nv-${i}-${idx}`">
                  <v-layout column wrap :data-qa="`applynow-layout-ntuf2b-${i}-${idx}`">
                    <v-container :data-qa="`applynow-container-hkg12-${i}-${idx}`">
                      <v-row :data-qa="`applynow-row-1n2k1q-${i}-${idx}`">
                        <div
                          v-if="group.list && group.list.length === 0"
                          class="pa-5 text-center"
                          style="width: 100%"
                          :data-qa="`applynow-div-ik23j7-${i}-${idx}`">
                          No offers available with text "{{ searchOffer }}" in
                          {{ filterType }} type.
                        </div>
                        <v-col
                          v-for="(offer, indx) in group.list"
                          :key="offer.offerId"
                          cols="12"
                          md="4"
                          :data-qa="`applynow-col-2j0v8-${i}-${idx}-${indx}`"
                        >
                          <!-- :min-height="getProductsCardHeight(offerItem.type)" -->
                          <v-card class="align-center" outlined :data-qa="`applynow-card-69rpby-${i}-${idx}-${indx}`">
                            <v-flex :data-qa="`applynow-flex-i1ip6r-${i}-${idx}-${indx}`">
                              <!-- :style="getProductsLabelHeight()" -->
                              <v-card-title class="mb-6" :data-qa="`applynow-card-title-de88t8-${i}-${idx}-${indx}`">
                                <font :color="primaryColor">
                                  {{ offer.label }}
                                </font>
                              </v-card-title>
                              <v-card-subtitle
                                class="pb-0"
                                v-if="offerItem.type === 'TD'"
                                :data-qa="`applynow-card-subtitle-7pj1ob-${i}-${idx}-${indx}`">
                                <div class="text-body-2 font-weight-regular" :data-qa="`applynow-div-pj294e-${i}-${idx}-${indx}`">
                                  <v-flex
                                    class="text-body-2 font-weight-regular"
                                   :data-qa="`applynow-flex-yh2ww-${i}-${idx}-${indx}`">
                                    {{ $t("applyNow.offerLabel.currency") }} :
                                    {{ offer.info.minAmount[0].currency }}
                                  </v-flex>
                                  <v-flex
                                    class="text-body-2 font-weight-regular"
                                    :data-qa="`applynow-flex-8ucns8-${i}-${idx}-${indx}`">
                                    {{
                                      $formatter.currency.format(
                                        offer.info.minAmount[0].value
                                      )
                                    }}
                                    {{
                                      $t(
                                        "applyNow.offerLabel.minimumOpeningBalance"
                                      )
                                    }}
                                  </v-flex>
                                  <v-flex
                                    class="text-body-2 font-weight-regular"
                                    :data-qa="`applynow-flex-luu40g-${i}-${idx}-${indx}`">
                                    {{
                                      $t(
                                        "applyNow.offerLabel.maximumDepositAmount"
                                      )
                                    }}
                                    {{
                                      $formatter.currency.format(
                                        offer.info.maxAmount[0].value
                                      )
                                    }}
                                    {{
                                      $t("applyNow.offerLabel.withMinTenor")
                                    }}
                                    {{ offer.info.minTenor[0].value }}
                                    {{ offer.info.minTenor[0].frequency }}
                                    {{ $t("applyNow.offerLabel.toMaximumOf") }}
                                    {{ offer.info.maxTenor[0].value }}
                                    {{ offer.info.minTenor[0].frequency }}
                                  </v-flex>
                                </div>
                              </v-card-subtitle>
                              <v-card-subtitle
                                class="pb-3"
                                v-if="offerItem.type !== 'TD'"
                                :data-qa="`applynow-card-subtitle-g5it0x-${i}-${idx}-${indx}`">
                                <div
                                  v-for="(value, key) in offer.info"
                                  :key="key"
                                  :data-qa="`applynow-div-5nmtg-${i}-${idx}-${indx}-${key}`">
                                  <div v-if="key === 'currency'" :data-qa="`applynow-div-1d2m2e-${i}-${idx}-${indx}-${key}`">
                                    <span
                                      class="text-body-2 font-weight-regular"
                                      :data-qa="`applynow-span-0wp59-${i}-${idx}-${indx}-${key}`">
                                      {{ $t(`applyNow.offerLabel.${key}`) }} :
                                    </span>
                                    <span
                                      class="text-body-2 font-weight-regular"
                                      :data-qa="`applynow-span-rfv71r-${i}-${idx}-${indx}-${key}`">
                                      {{ value }}
                                    </span>
                                  </div>
                                  <div v-if="offer.expandMoreDetails" :data-qa="`applynow-div-x308hg-${i}-${idx}-${indx}-${key}`">
                                    <div
                                      v-if="
                                        key !== 'currency' &&
                                        offerItem.type === 'SVGS' &&
                                        moreDetailsSVGS.includes(key)
                                      "
                                      :data-qa="`applynow-div-azl9er-${i}-${idx}-${indx}-${key}`">
                                      <span
                                        class="text-body-2 font-weight-regular"
                                        :data-qa="`applynow-span-zn63gji-${i}-${idx}-${indx}-${key}`">
                                        {{ $t(`applyNow.offerLabel.${key}`) }} :
                                      </span>
                                      <span
                                        v-if="
                                          key !== 'currency' &&
                                          applyUnit.includes(key)
                                        "
                                        class="text-body-2 font-weight-regular"
                                        :data-qa="`applynow-span-xcto4a-${i}-${idx}-${indx}-${key}`">
                                        {{ $formatter.currency.format(value) }}
                                      </span>
                                      <span
                                        v-if="
                                          key !== 'currency' &&
                                          !applyUnit.includes(key)
                                        "
                                        class="text-body-2 font-weight-regular"
                                        :data-qa="`applynow-span-7mix9a-${i}-${idx}-${indx}-${key}`">
                                        {{
                                          key === "creditInterestRateFixed"
                                            ? `${value} %`
                                            : value
                                        }}
                                      </span>
                                    </div>
                                    <div
                                      v-if="
                                        key !== 'currency' &&
                                        offerItem.type === 'CACC' &&
                                        moreDetailsCACC.includes(key)
                                      "
                                      :data-qa="`applynow-div-bov59c-${i}-${idx}-${indx}-${key}`">
                                      <span
                                        class="text-body-2 font-weight-regular"
                                        :data-qa="`applynow-span-twtlf-${i}-${idx}-${indx}-${key}`">
                                        {{ $t(`applyNow.offerLabel.${key}`) }} :
                                      </span>
                                      <span
                                        v-if="
                                          key !== 'currency' &&
                                          applyUnit.includes(key)
                                        "
                                        class="text-body-2 font-weight-regular"
                                        :data-qa="`applynow-span-wv90sd-${i}-${idx}-${indx}-${key}`">
                                        {{ $formatter.currency.format(value) }}
                                      </span>
                                      <span
                                        v-if="
                                          key !== 'currency' &&
                                          !applyUnit.includes(key)
                                        "
                                        class="text-body-2 font-weight-regular"
                                        :data-qa="`applynow-span-f2del-${i}-${idx}-${indx}-${key}`">
                                        {{
                                          key === "creditInterestRateFixed" ||
                                          key === "debitInterestRateFixed"
                                            ? `${value} %`
                                            : value
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </v-card-subtitle>
                              <v-expand-transition
                                v-if="
                                  offerItem.type === 'TD' &&
                                  offer.expandMoreDetails
                                "
                                :data-qa="`applynow-expand-transition-tigpvs-${i}-${idx}-${indx}`">
                                <div class="mt-n2" :data-qa="`applynow-div-qogbhq-${i}-${idx}-${indx}`">
                                  <v-card-text :data-qa="`applynow-card-text-5cm71b-${i}-${idx}-${indx}`">
                                    <div
                                      v-for="(value, key) in offer.info"
                                      :key="key"
                                     :data-qa="`applynow-div-7cbzyl-${i}-${idx}-${indx}-${key}`">
                                      <span
                                        v-if="
                                          moreDetailsFloatingFields.includes(
                                            key
                                          )
                                        "
                                        class="text-body-2 font-weight-regular text-left"
                                        :data-qa="`applynow-span-kvrkbg-${i}-${idx}-${indx}-${key}`">
                                        <ul style="list-style: none" data-qa="applynow-ul-zhmeg9">
                                          <li :data-qa="`applynow-li-j5dos2-${i}-${idx}-${indx}-${key}`">
                                            <span
                                              v-if="
                                                key === 'interestRateFloating'
                                              "
                                              :data-qa="`applynow-span-ufz53e-${i}-${idx}-${indx}-${key}`">
                                              {{
                                                value === "No"
                                                  ? $t(
                                                      "applyNow.offerLabel.rateOfInterest"
                                                    )
                                                  : $t(
                                                      "applyNow.offerLabel.interestRateFloating"
                                                    )
                                              }}
                                            </span>
                                            <span
                                              v-if="
                                                key !== 'interestRateFloating'
                                              "
                                              :data-qa="`applynow-span-qn1qw7-${i}-${idx}-${indx}-${key}`">
                                              {{
                                                $t(`applyNow.offerLabel.${key}`)
                                              }}
                                              : {{ value }}
                                            </span>
                                          </li>
                                        </ul>
                                      </span>
                                    </div>
                                    <div class="px-6" :data-qa="`applynow-div-uxg5ve-${i}-${idx}-${indx}`">
                                      <a
                                        text
                                        class="font-weight-light"
                                        style="color: $defaultBorderColor !important"
                                        @click="
                                          showInterestRates(offer, offerItem)
                                        "
                                        :data-qa="`showInterestRates-${i}-${idx}-${indx}`"
                                        >{{
                                          $t("applyNow.viewInterestRateLabel")
                                        }}
                                      </a>
                                    </div>
                                  </v-card-text>
                                </div>
                              </v-expand-transition>
                              <v-divider
                                v-if="offer.expandMoreDetails"
                               :data-qa="`applynow-divider-59erfa-${i}-${idx}-${indx}`"></v-divider>
                              <v-flex :data-qa="`applynow-flex-gohs5g-${i}-${idx}-${indx}`">
                                <v-card-actions class="mt-n2" :data-qa="`applynow-card-actions-5w1xjk-${i}-${idx}-${indx}`">
                                  <v-row justify="end" class="text-right" :data-qa="`applynow-row-n59mwe-${i}-${idx}-${indx}`">
                                    <v-btn
                                      class="ma-2 text-capitalize py-2 px-4"
                                      outlined
                                      :data-qa="`expandMoreDetails-${i}-${idx}-${indx}`"
                                      :color="primaryColor"
                                      @click="
                                        getProductParams(
                                          offer,
                                          offerItem,
                                          false
                                        )
                                      "
                                    >
                                      <v-icon right class="pr-2 material-symbols-outlined" size="18px" :data-qa="`applynow-icon-ad8d9rn-${i}-${idx}-${indx}`">
                                        {{
                                          offer.expandMoreDetails
                                            ? "keyboard_arrow_up"
                                            : "keyboard_arrow_down"
                                        }}
                                      </v-icon>
                                      {{ $t("applyNow.moreDetailsLable") }}
                                    </v-btn>
                                    <v-btn
                                      class="text-capitalize ma-2 white--text py-2 px-4"
                                      :color="primaryColor"
                                      :data-qa="`applyOffer-${i}-${idx}-${indx}`"
                                      @click="applyOffer(offer, offerItem)"
                                    >
                                      {{ $t("common.applyLabel") }}
                                    </v-btn>
                                  </v-row>
                                </v-card-actions>
                              </v-flex>
                            </v-flex>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <Modal :config="modalConfig" @btn1Action="hideInterests">
      <span slot="modalContent" data-qa="applynow-span-nzkddz">
        <v-data-table
          :headers="headers"
          :items="interestRates"
          multi-sort
          class="elevation-1"
         data-qa="applynow-data-table-ahnwd8"></v-data-table>
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'
import event from '@/util/event'
import Loader from '../components/common/Loader.vue'
export default {
  name: 'Offers',
  data () {
    return {
      offerList: null,
      offerListCopy: null,
      filterType: null,
      applyNow: null,
      searchOffer: '',
      offerType: null,
      currentTab: null,
      excludeLabels: ['minTenor', 'maxTenor', 'minBalance', 'maxBalance'],
      applyUnit: ['minBalance', 'maxBalance', 'minAmount', 'maxAmount'],
      moreDetailsFloatingFields: ['interestPayout', 'interestRateFloating'],
      moreDetailsCACC: [
        'minBalance',
        'creditInterestRateFixed',
        'debitInterestRateFixed'
      ],
      moreDetailsSVGS: ['minBalance', 'creditInterestRateFixed'],
      modalConfig: {
        enabled: false,
        persistent: false,
        btn1Label: 'Close',
        outlinedSaveBtn: true,
        title: this.$t('applyNow.modalTitle'),
        width: 800
      },
      headers: [
        { text: 'Minimum Amount', value: 'minAmount' },
        { text: 'Maximum Amount', value: 'maxAmount' },
        { text: 'Minimum Tenor', value: 'minTenor' },
        { text: 'Maximum Tenor', value: 'maxTenor' },
        { text: 'Effective Interest Rate', value: 'effectiveIR' }
      ],
      interestRates: [],
      loaderEnabled: false,
      noOffersAvailable: false
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    Loader
  },
  methods: {
    applyOffer (item, offerItem) {
      this.getProductParams(item, offerItem, true)
    },
    getProductParams (offer, offerItem, apply) {
      const self = this
      if (apply && offer.cached) {
        self.$router.push({
          name: 'OpenAccount',
          params: { item: offer, type: offerItem.type }
        })
      }
      if (!offer.cached) {
        if (offerItem.type === 'TD') {
          commonService.getTDProductSummary(offer.offerId).then((res) => {
            self.cacheOfferDetails(offerItem.type, offer, res, apply)
          })
        }
        if (offerItem.type === 'SVGS' || offerItem.type === 'CACC') {
          commonService.getCASAProductSummary(offer.offerId).then((res) => {
            self.cacheOfferDetails(offerItem.type, offer, res, apply)
          })
        }
      } else {
        offer.expandMoreDetails = !offer.expandMoreDetails
      }
    },
    storeCachedData (type, offer, res, apply) {
      const self = this
      for (const i in self.offerList[type].groups) {
        self.offerList[type].groups[i].list.map((val) => {
          if (val.offerId === offer.offerId) {
            if (type === 'deposit') {
              val.offerDetails = res
              val.info.interestRateId = res.interestRateId
              val.info.interestRateFloating = res.interestRateFloating
                ? res.interestRateFloating
                : 'No'
              val.info.interestPayout =
                res.interestPayoutMethod === 'PIP'
                  ? self.$t(`applyNow.offerLabel.${res.interestPayoutMethod}`) +
                    ', ' +
                    self.$t(
                      `applyNow.offerLabel.units.${res.payoutFrequencyPeriod}`
                    )
                  : self.$t(`applyNow.offerLabel.${res.interestPayoutMethod}`)
              val.cached = true
              val.expandMoreDetails = true
            }
            if (type === 'savings' || type === 'current') {
              val.offerDetails = res
              if (
                res.minimumAccountOpeningBalance &&
                res.minimumAccountOpeningBalance[0]
              ) {
                val.info.minBalance = res.minimumAccountOpeningBalance[0].value
              } else {
                val.info.minBalance = res.minimumAccountOpeningBalance.value
              }
              val.info.creditInterestRateFixed = res.creditInterestRateFixed
              val.info.debitInterestRateFixed = res.debitInterestRateFixed
              val.expandMoreDetails = true
              val.cached = true
            }
          }
        })
      }
      sessionStorage.setItem('products', JSON.stringify(self.offerList))
      if (apply) {
        const offerType =
          type === 'savings' ? 'SVGS' : type === 'current' ? 'CACC' : 'TD'
        self.$router.push({
          name: 'OpenAccount',
          params: { item: offer, type: offerType }
        })
      }
    },
    cacheOfferDetails (type, offer, res, apply) {
      switch (type) {
        case 'SVGS':
          this.storeCachedData('savings', offer, res, apply)
          break
        case 'CACC':
          this.storeCachedData('current', offer, res, apply)
          break
        case 'TD':
          this.storeCachedData('deposit', offer, res, apply)
          break
        default:
          console.log('default')
      }
    },
    close () {},
    setFilterType () {
      this.filterType =
        this.currentTab === 2
          ? 'deposit'
          : this.currentTab === 1
            ? 'current'
            : 'savings'
      const x = JSON.stringify(this.offerList)
      if (x) {
        this.offerListCopy = JSON.parse(x)
      }
    },
    resetOfferData () {
      this.searchOffer = ''
      const y = JSON.stringify(this.offerListCopy)
      this.offerList = JSON.parse(y)
    },
    filterOfferList () {
      const self = this
      if (!self.searchOffer || self.searchOffer.trim().length === 0) {
        const y = JSON.stringify(
          this.offerListCopy[this.filterType].groups[0].list
        )
        this.offerList[this.filterType].groups[0].list = JSON.parse(y)
      } else {
        const x = _.filter(
          this.offerListCopy[this.filterType].groups[0].list,
          (o) => {
            return (
              o.label.toLowerCase().indexOf(self.searchOffer.toLowerCase()) !==
              -1
            )
          }
        )
        this.offerList[this.filterType].groups[0].list = x
      }
    },
    showInterestRates (offer, offerItem) {
      this.modalConfig.enabled = true
      this.interestRates = []
      if (offer.interestRates) {
        this.interestRates = offer.interestRates
      } else {
        this.getTermDepositInterestRates(offer, offerItem)
      }
    },
    hideInterests () {
      this.modalConfig.enabled = false
    },
    async getTermDepositInterestRates (offer, offerItem) {
      const self = this
      await commonService
        .getTermDepositInterestRates(offer.info.interestRateId)
        .then((res) => {
          for (const i in res.interestRateTiers) {
            const calculatedInterests = {
              ...res.interestRateTiers[i],
              minAmount: self.$formatter.currency.format(
                res.interestRateTiers[i].balanceFrom
              ),
              maxAmount: self.$formatter.currency.format(
                res.interestRateTiers[i].balanceTo
              ),
              minTenor: res.interestRateTiers[i].tenorFrom + ' ' + res.duration,
              maxTenor: res.interestRateTiers[i].tenorTo + ' ' + res.duration,
              effectiveIR: res.interestRateTiers[i].interestRate + '%'
            }
            self.interestRates.push(calculatedInterests)
          }
          offer.interestRates = self.interestRates
          sessionStorage.setItem('products', JSON.stringify(self.offerList))
        })
    },
    getParamValues (paramsArr) {
      return Object.values(paramsArr[0]).join(' ')
    },
    ifDataAvailable () {
      return JSON.parse(sessionStorage.getItem('products'))
    },
    getProductsCardHeight (accountType) {
      return window.innerWidth >= 1264 &&
        window.innerWidth < 1904 &&
        accountType === 'TD'
        ? '290'
        : '200'
    },
    getProductsLabelHeight () {
      if (window.innerWidth >= 1024) {
        return window.innerWidth < 1264 ? 'height:120px' : 'height:90px'
      }
    }
  },
  watch: {
    currentTab () {
      this.setFilterType()
    }
  },
  created () {
    const self = this
    self.loaderEnabled = true
    this.offerType = this.$route.params.offerType
    if (this.offerType && this.offerType === 'TD') {
      this.currentTab = 2
    } else if (this.offerType && this.offerType === 'CACC') {
      this.currentTab = 1
    } else {
      this.currentTab = 0
    }
    event.$on('set_products', () => {
      self.offerList = JSON.parse(sessionStorage.getItem('products'))
      if (!self.offerList) {
        self.noOffersAvailable = true
      }
      self.setFilterType()
      self.loaderEnabled = false
    })
    if (!this.ifDataAvailable()) {
      this.loaderEnabled = true
      preload.getListOfProducts()
    } else {
      self.offerList = JSON.parse(sessionStorage.getItem('products'))
      self.setFilterType()
      this.loaderEnabled = false
    }
  }
}
</script>

<style lang="scss" scoped>
.applyNow-container {
  &__tabPadding {
    padding-left: 14px;
    padding-right: 14px;
  }
}
</style>
